import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth-service';
import { PathResolveService } from './path-resolve.service';

export const organizationAdminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.canManageOrganization() || router.createUrlTree([PathResolveService.getCockpitPath()]);
};